import styled from 'styled-components';
import { colors, borderRadius, shadows, zIndex } from './designTokens';

// 모바일 메인 컨텐츠 컨테이너
export const MobileMainContent = styled.div`
  padding: 16px;
  background-color: ${colors.semantic.background.secondary};
  min-height: 100vh;
  max-width: 100%;
  overflow-x: hidden;
`;

// 모바일 통계 카드 그리드
export const MobileStatsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; // 2열 그리드
  gap: 12px;
  margin-bottom: 20px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr; // 작은 화면에서는 1열
    gap: 10px;
  }
`;

// 모바일 차트 섹션
export const MobileChartsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 20px;
  }
`;

// 모바일 로딩 스피너
export const MobileLoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;

  .spinner {
    width: 32px;
    height: 32px;
    border: 3px solid ${colors.semantic.border.primary};
    border-top: 3px solid ${colors.primary[500]};
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

// 모바일 에러 메시지
export const MobileErrorMessage = styled.div`
  background-color: ${colors.error[50]};
  border: 1px solid ${colors.error[200]};
  color: ${colors.error[600]};
  padding: 12px 16px;
  border-radius: ${borderRadius.lg};
  text-align: center;
  font-size: 14px;
  margin: 16px 0;
`;

// 모바일 테이블 스타일
export const MobileTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: ${colors.semantic.background.primary};
  font-size: 13px;

  th,
  td {
    padding: 8px 6px;
    text-align: left;
    border-bottom: 1px solid ${colors.semantic.border.primary};
    word-break: break-word;
  }

  th {
    background-color: ${colors.semantic.background.secondary};
    font-weight: 600;
    color: ${colors.semantic.text.secondary};
    font-size: 12px;
    position: sticky;
    top: 0;
    z-index: ${zIndex.docked};
  }

  tr:hover {
    background-color: ${colors.neutral[50]};
  }

  tr:last-child td {
    border-bottom: none;
  }
`;

// 모바일 테이블 헤더
export const MobileTableHeader = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid ${colors.semantic.border.primary};
  background-color: ${colors.semantic.background.secondary};

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: ${colors.secondary[800]};
  }
`;

// 모바일 테이블 섹션
export const MobileTableSection = styled.div`
  background-color: ${colors.semantic.background.primary};
  border-radius: ${borderRadius.xl};
  overflow: hidden;
  box-shadow: ${shadows.base};
  border: 1px solid ${colors.semantic.border.primary};
`;

// 모바일 카드 컨테이너
export const MobileCardContainer = styled.div<{ $isActive?: boolean; $clickable?: boolean }>`
  background-color: ${colors.semantic.background.primary};
  border-radius: ${borderRadius.xl};
  padding: 16px;
  box-shadow: ${shadows.base};
  border: 1px solid ${colors.semantic.border.primary};
  transition: all 0.2s ease-in-out;

  ${props =>
    props.$clickable &&
    `
    cursor: pointer;

    &:hover {
      box-shadow: ${shadows.md};
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
    }
  `}

  ${props =>
    props.$isActive &&
    `
    border-color: ${colors.primary[500]};
    box-shadow: ${shadows.primary};
    transform: translateY(-1px);
  `}
`;

// 모바일 차트 컨테이너
export const MobileChartContainer = styled.div`
  background-color: ${colors.semantic.background.primary};
  border-radius: ${borderRadius.lg};
  padding: 4px;
  box-shadow: none;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: auto;
  box-sizing: border-box;
`;

// 모바일 차트 제목
export const MobileChartTitle = styled.h3`
  margin: 0 0 10px 0;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.secondary[800]};
  text-align: center;
`;

// 모바일 상세 버튼
export const MobileDetailButton = styled.button`
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 500;
  color: ${colors.primary[500]};
  background-color: ${colors.primary[50]};
  border: 1px solid ${colors.primary[200]};
  border-radius: ${borderRadius.base};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  white-space: nowrap;

  &:hover {
    background-color: ${colors.primary[100]};
    border-color: ${colors.primary[300]};
    color: ${colors.primary[600]};
  }
`;
